import { useQuery } from 'react-query';

import { adReviewRecommendGroup } from '../graphql/ad_review_recommend_group.2';
import { AdReviewRecommendGroup_ad_review_recommend_group_UxGoodsGroup } from '../graphql/ad_review_recommend_group_types.2';

export const useAdReviewRecommendGroup = (catalog_product_id: string) => {
  return useQuery(
    ['requestAdReviewRecommendGroup', catalog_product_id],
    () => requestAdReviewRecommendGroup(catalog_product_id),
    { refetchOnWindowFocus: false },
  );
};

export async function requestAdReviewRecommendGroup(catalog_product_id: string) {
  try {
    const {
      data: { ad_review_recommend_group },
    } = await adReviewRecommendGroup({ catalog_product_id }, { show_alert: false });

    return ad_review_recommend_group as AdReviewRecommendGroup_ad_review_recommend_group_UxGoodsGroup[];
  } catch (e) {
    console.error(e);
  }
}
